// Tap-to-call / text / email / map links for phone screens (plan section 4). Pure: they only
// build hrefs. Customer and vendor phone numbers are free text ("(620) 555-0100 x12", "ext 4").

/** Digits (and a leading +) a phone can dial, with an extension as ",<ext>" (pause, then dial). */
export function dialable(phone) {
  if (phone == null) return null;
  const raw = String(phone).trim();
  if (!raw) return null;
  const m = /^(.*?)(?:\s*(?:x|ext\.?|extension|#)\s*(\d+))?\s*$/i.exec(raw);
  const main = (m ? m[1] : raw).replace(/[^\d+]/g, "").replace(/(?!^)\+/g, "");
  const digits = main.replace(/\D/g, "");
  if (digits.length < 7) return null;
  const ext = m && m[2] ? `,${m[2]}` : "";
  return `${main}${ext}`;
}

export function telHref(phone) {
  const d = dialable(phone);
  return d ? `tel:${d}` : null;
}

export function smsHref(phone) {
  const d = dialable(phone);
  if (!d) return null;
  return `sms:${d.split(",")[0]}`;
}

const EMAIL_RE = /^[^\s@,;<>]+@[^\s@,;<>]+\.[^\s@,;<>]+$/;

export function mailtoHref(email, { subject = "" } = {}) {
  const e = email == null ? "" : String(email).trim();
  if (!EMAIL_RE.test(e)) return null;
  return subject ? `mailto:${e}?subject=${encodeURIComponent(subject)}` : `mailto:${e}`;
}

/** One line from address parts, blanks skipped: "123 Main St, Suite 4, Coffeyville, KS 67337". */
export function addressLine({ address, address_line2: line2, city, state, zip, zip_code: zipCode } = {}) {
  const cityState = [city, [state, zip || zipCode].filter(Boolean).join(" ")].filter((s) => s && String(s).trim()).join(", ");
  return [address, line2, cityState].filter((s) => s && String(s).trim()).join(", ");
}

/** Apple Maps on iPhone / iPad / Mac (opens the Maps app), Google Maps everywhere else. */
export function mapsHref(address, { apple = isApplePlatform() } = {}) {
  const q = typeof address === "string" ? address.trim() : addressLine(address || {});
  if (!q) return null;
  return apple
    ? `https://maps.apple.com/?q=${encodeURIComponent(q)}`
    : `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

export function isApplePlatform() {
  try {
    const ua = navigator.userAgent || "";
    return /iPhone|iPad|iPod|Macintosh/.test(ua);
  } catch (e) {
    return false;
  }
}
